var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: _vm.selection,
          "before-reset-search": _vm.beforeResetSearch,
          "default-sort": _vm.defaultSort,
          "before-query-search": _vm.beforeQuerySearch,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
          "sort-change": _vm.sortChange,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-row",
                  { staticStyle: { padding: "0 10px" }, attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "BusinessPurchaseForecast.skuLabelList"
                              ),
                            },
                          },
                          [
                            _c("BjSelectLov", {
                              attrs: { "option-list": _vm.SKU_TAG_LIST },
                              model: {
                                value: _vm.queryParams.skuLabels,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "skuLabels", $$v)
                                },
                                expression: "queryParams.skuLabels",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "BusinessPurchaseForecast.isSuggest"
                              ),
                            },
                          },
                          [
                            _c("BjSelectLov", {
                              attrs: { "option-list": _vm.STATUS_YES_NUM },
                              model: {
                                value: _vm.queryParams.isSuggest,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "isSuggest", $$v)
                                },
                                expression: "queryParams.isSuggest",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "BusinessPurchaseOrderDetail.table.skuName"
                              ),
                            },
                          },
                          [
                            _c("BjInput", {
                              attrs: {
                                maxlength: _vm.MAX_LENGTH.DEFAULT,
                                placeholder: _vm.$t("inputText"),
                                clearable: "",
                              },
                              nativeOn: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.handleQuery.apply(null, arguments)
                                },
                              },
                              model: {
                                value: _vm.queryParams.skuName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "skuName", $$v)
                                },
                                expression: "queryParams.skuName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c("BjFormItemCode", {
                          attrs: {
                            label: _vm.$t(
                              "BusinessPurchaseOrderDetail.table.skuCode"
                            ),
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.skuCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "skuCode", $$v)
                            },
                            expression: "queryParams.skuCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { staticStyle: { padding: "0 10px" }, attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("goodsPage.categoryName"),
                              prop: "categoryIdList",
                            },
                          },
                          [
                            _c("BjGoodsTypeTreeSelect", {
                              attrs: { limit: 1, multiple: "" },
                              on: { change: _vm.selectIds },
                              model: {
                                value: _vm.queryParams.categoryIdList,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryParams,
                                    "categoryIdList",
                                    $$v
                                  )
                                },
                                expression: "queryParams.categoryIdList",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("BusinessPurchaseForecast.isSale"),
                            },
                          },
                          [
                            _c("BjSelectLov", {
                              attrs: { "option-list": _vm.STATUS_YES_NUM },
                              model: {
                                value: _vm.queryParams.isSale,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "isSale", $$v)
                                },
                                expression: "queryParams.isSale",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "BusinessPurchaseForecast.priorityLevel"
                              ),
                            },
                          },
                          [
                            _c("BjSelectLov", {
                              attrs: { "option-list": _vm.PRIORITY_LEVEL_LIST },
                              model: {
                                value: _vm.queryParams.priorityLevel,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryParams,
                                    "priorityLevel",
                                    $$v
                                  )
                                },
                                expression: "queryParams.priorityLevel",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "BusinessPurchaseOrderList.table.Buyer"
                              ),
                            },
                          },
                          [
                            _c("BjInput", {
                              attrs: {
                                maxlength: _vm.MAX_LENGTH.DEFAULT,
                                placeholder: _vm.$t("inputText"),
                                clearable: "",
                              },
                              nativeOn: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.handleQuery.apply(null, arguments)
                                },
                              },
                              model: {
                                value: _vm.queryParams.buyerName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "buyerName", $$v)
                                },
                                expression: "queryParams.buyerName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { staticStyle: { padding: "0 10px" }, attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "BusinessPurchaseForecast.isIgnore"
                              ),
                            },
                          },
                          [
                            _c("BjSelectLov", {
                              attrs: { "option-list": _vm.STATUS_YES_NUM },
                              model: {
                                value: _vm.queryParams.isIgnore,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "isIgnore", $$v)
                                },
                                expression: "queryParams.isIgnore",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "SalesOrderToBeApproved.form.Approval"
                              ),
                            },
                          },
                          [
                            _c("BjSelectLov", {
                              attrs: {
                                "option-list": _vm.IGNORE_AUDIT_STATUS_LIST,
                              },
                              model: {
                                value: _vm.queryParams.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "status", $$v)
                                },
                                expression: "queryParams.status",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "BusinessPurchaseForecast.erpRequestReturnDate"
                              ),
                            },
                          },
                          [
                            _c("BjDateTimerangePicker", {
                              attrs: {
                                placeholder: _vm.$t(
                                  "BusinessPurchaseForecast.erpRequestReturnDate"
                                ),
                              },
                              model: {
                                value: _vm.queryParamsERP_returnDate,
                                callback: function ($$v) {
                                  _vm.queryParamsERP_returnDate = $$v
                                },
                                expression: "queryParamsERP_returnDate",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "beforeSearchBtn",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: 24 - _vm.colSpan } },
                  [
                    _c("BjStatusTabs", {
                      attrs: {
                        value: _vm.auditTabsValue,
                        "option-list": _vm.TAB_LIST,
                      },
                      on: { handleTabClick: _vm.handleTabClick },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    _vm.auditTabsValue === "ALL"
                      ? _c(
                          "el-button",
                          {
                            staticClass: "main-btn",
                            attrs: { disabled: !_vm.selectedRows.length },
                            on: {
                              click: function ($event) {
                                return _vm.createPurchaseOrder()
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "BusinessPurchaseForecast.createPurchaseApply"
                                )
                              )
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.auditTabsValue === "ALL"
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.onExport },
                          },
                          [_vm._v(_vm._s(_vm.$t("exportText")))]
                        )
                      : _vm._e(),
                    _vm.auditTabsValue === "ALL"
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.ignore },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("BusinessPurchaseForecast.ignore"))
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.auditTabsValue === "IGNORE_REVIEW" &&
                    _vm.IgnoreAuditPermission
                      ? _c(
                          "el-button",
                          {
                            staticClass: "main-btn",
                            attrs: { type: "primary" },
                            on: { click: _vm.ignoreAuditDialog },
                          },
                          [_vm._v(_vm._s(_vm.$t("table.auditText")))]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function () {
                            return _vm.$refs.tooltipDialog.show()
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("BusinessPurchaseForecast.userManual"))
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop === "skuCode"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: "skuCode",
                            title: _vm.$t(
                              "BusinessPurchaseOrderDetail.table.skuCode"
                            ),
                            width: "150px",
                            sortable: "",
                          },
                        })
                      : col.prop === "suggestQty"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: "suggestQty",
                            width: "140px",
                            sortable: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "BusinessPurchaseForecast.suggestQty"
                                          )
                                        ) +
                                        " "
                                    ),
                                    _c(
                                      "el-tooltip",
                                      { attrs: { placement: "top" } },
                                      [
                                        _c(
                                          "span",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "BusinessPurchaseForecast.suggestQtyTooltip"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("i", {
                                          staticClass: "el-icon-question",
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : col.prop === "totalQty"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: "totalQty",
                            width: "165px",
                            sortable: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "BusinessPurchaseForecast.totalQty"
                                          )
                                        ) +
                                        " "
                                    ),
                                    _c(
                                      "el-tooltip",
                                      { attrs: { placement: "top" } },
                                      [
                                        _c(
                                          "span",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "BusinessPurchaseForecast.totalQtyTooltip"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("i", {
                                          staticClass: "el-icon-question",
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : col.prop === "totalQtySort"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: "totalQtySort",
                            title: _vm.$t(
                              "BusinessPurchaseForecast.totalQtySort"
                            ),
                            width: "140px",
                            sortable: "",
                          },
                        })
                      : col.prop === "inApprovalQty"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: "inApprovalQty",
                            width: "130px",
                            sortable: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "BusinessPurchaseForecast.inApprovalQty"
                                          )
                                        ) +
                                        " "
                                    ),
                                    _c(
                                      "el-tooltip",
                                      { attrs: { placement: "top" } },
                                      [
                                        _c(
                                          "span",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "BusinessPurchaseForecast.inApprovalQtyTooltip"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("i", {
                                          staticClass: "el-icon-question",
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : col.prop === "approvedQty"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: "approvedQty",
                            width: "180px",
                            sortable: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "BusinessPurchaseForecast.approvedQty"
                                          )
                                        ) +
                                        " "
                                    ),
                                    _c(
                                      "el-tooltip",
                                      { attrs: { placement: "top" } },
                                      [
                                        _c(
                                          "span",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "BusinessPurchaseForecast.approvedQtyTooltip1"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("i", {
                                          staticClass: "el-icon-question",
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : col.prop === "schedulingQty"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: "schedulingQty",
                            width: "170px",
                            sortable: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "BusinessPurchaseForecast.schedulingQty"
                                          )
                                        ) +
                                        " "
                                    ),
                                    _c(
                                      "el-tooltip",
                                      { attrs: { placement: "top" } },
                                      [
                                        _c(
                                          "span",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "BusinessPurchaseForecast.schedulingQtyTooltip"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("i", {
                                          staticClass: "el-icon-question",
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : col.prop === "shippingQty"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: "shippingQty",
                            width: "170px",
                            sortable: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "BusinessPurchaseForecast.shippingQty"
                                          )
                                        ) +
                                        " "
                                    ),
                                    _c(
                                      "el-tooltip",
                                      { attrs: { placement: "top" } },
                                      [
                                        _c(
                                          "span",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "BusinessPurchaseForecast.shippingQtyTooltip"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("i", {
                                          staticClass: "el-icon-question",
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : col.prop === "shipmentQty"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: "shipmentQty",
                            width: "170px",
                            sortable: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "BusinessPurchaseForecast.shipmentQty"
                                          )
                                        ) +
                                        " "
                                    ),
                                    _c(
                                      "el-tooltip",
                                      { attrs: { placement: "top" } },
                                      [
                                        _c(
                                          "span",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "BusinessPurchaseForecast.shipmentQtyTooltip"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("i", {
                                          staticClass: "el-icon-question",
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : col.prop === "onHandQty"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: "onHandQty",
                            width: "115px",
                            sortable: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "BusinessPurchaseForecast.onHandQty"
                                          )
                                        ) +
                                        " "
                                    ),
                                    _c(
                                      "el-tooltip",
                                      { attrs: { placement: "top" } },
                                      [
                                        _c(
                                          "span",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "BusinessPurchaseForecast.onHandQtyTooltip"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("i", {
                                          staticClass: "el-icon-question",
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : col.prop === "preOccupyQty"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: "preOccupyQty",
                            width: "180px",
                            sortable: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "BusinessPurchaseForecast.preOccupyQty"
                                          )
                                        ) +
                                        " "
                                    ),
                                    _c(
                                      "el-tooltip",
                                      { attrs: { placement: "top" } },
                                      [
                                        _c(
                                          "span",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "BusinessPurchaseForecast.preOccupyQtyTooltip"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("i", {
                                          staticClass: "el-icon-question",
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : col.prop === "priorityLevel"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: "priorityLevel",
                            width: "130px",
                            sortable: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "BusinessPurchaseForecast.priorityLevel"
                                          )
                                        ) +
                                        " "
                                    ),
                                    _c(
                                      "el-tooltip",
                                      { attrs: { placement: "top" } },
                                      [
                                        _c(
                                          "span",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "BusinessPurchaseForecast.priorityLevelTooltip1"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("i", {
                                          staticClass: "el-icon-question",
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type:
                                            row[col.prop] === "3"
                                              ? "danger"
                                              : "",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              _vm.PRIORITY_LEVEL_LIST.bjGet(
                                                row[col.prop]
                                              )
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : col.prop === "erpRequestReturnDate"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: "erpRequestReturnDate",
                            width: "160px",
                            sortable: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "BusinessPurchaseForecast.erpRequestReturnDate"
                                          )
                                        ) +
                                        " "
                                    ),
                                    _c(
                                      "el-tooltip",
                                      { attrs: { placement: "top" } },
                                      [
                                        _c(
                                          "span",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "BusinessPurchaseForecast.erpRequestReturnDateTooltip1"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("i", {
                                          staticClass: "el-icon-question",
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    false
                                      ? void 0
                                      : col.prop === "skuLabelList"
                                      ? [
                                          _c("BjTagList", {
                                            attrs: {
                                              "tag-code-array": row[col.prop],
                                              size: "mini",
                                            },
                                          }),
                                        ]
                                      : col.prop === "remark"
                                      ? [
                                          _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                effect: "dark",
                                                content: row[col.prop],
                                                placement: "top-start",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-info",
                                                staticStyle: {
                                                  color: "#082dc3",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      : col.prop === "remark1"
                                      ? [
                                          _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                effect: "dark",
                                                content: row[col.prop],
                                                placement: "top-start",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-info",
                                                staticStyle: {
                                                  color: "#082dc3",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      : col.prop === "actualProfitRate"
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("profitMarginFilter")(
                                                row[col.prop]
                                              )
                                            )
                                          ),
                                        ]
                                      : col.prop === "isSuggest"
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: row[col.prop]
                                                ? "success"
                                                : "info",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.STATUS_YES_NUM.bjGet(
                                                    row[col.prop]
                                                  )
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : col.prop === "isSale"
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: row[col.prop]
                                                ? "success"
                                                : "info",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.STATUS_YES_NUM.bjGet(
                                                    row[col.prop]
                                                  )
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : col.prop === "isIgnore"
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: row[col.prop]
                                                ? "success"
                                                : "info",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.STATUS_YES_NUM.bjGet(
                                                    row[col.prop]
                                                  )
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : col.prop === "status"
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                _vm.IGNORE_AUDIT_STATUS_LIST.bjGet(
                                                  row[col.prop]
                                                )
                                              )
                                            )
                                          ),
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                row[col.prop],
                                                row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "edit-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.createPurchaseOrder(row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "BusinessPurchaseForecast.purchaseApply"
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "BjDialog",
        {
          attrs: {
            title: _vm.$t("BusinessPurchaseForecast.title"),
            visible: _vm.visible,
            width: "800px",
          },
          on: {
            close: function ($event) {
              _vm.visible = false
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formIgnore",
              attrs: { model: _vm.formIgnore, rules: _vm.rules },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("BusinessPurchaseForecast.deadLine"),
                            prop: "endTime",
                          },
                        },
                        [
                          _c("el-date-picker", {
                            staticClass: "full-width",
                            attrs: {
                              type: "date",
                              format: "dd/MM/yyyy",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              "picker-options": _vm.pickerOptions,
                              placeholder: _vm.$t("chooseText"),
                              clearable: "",
                            },
                            model: {
                              value: _vm.formIgnore.endTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.formIgnore, "endTime", $$v)
                              },
                              expression: "formIgnore.endTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "BusinessPurchaseForecast.ignoreReason"
                            ),
                            prop: "remark",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              autosize: "",
                              type: "textarea",
                              "show-word-limit": "",
                              placeholder: _vm.$t("inputText"),
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handleQuery.apply(null, arguments)
                              },
                            },
                            model: {
                              value: _vm.formIgnore.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.formIgnore, "remark", $$v)
                              },
                              expression: "formIgnore.remark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("cancelText")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.ignoreConfirm },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("IgnoreAudit", { ref: "IgnoreAudit", on: { confirm: _vm.onConfirm } }),
      _c("tooltipDialog", { ref: "tooltipDialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }